import React from 'react'
import style from './style.module.less'

const Title = ({ title }) => {
  return <div className={style.title}>{title}</div>
}

export default Title
